import { render, staticRenderFns } from "./irrigation.vue?vue&type=template&id=8f64d996&"
import script from "./irrigation.vue?vue&type=script&lang=js&"
export * from "./irrigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports